<template>
  <div class="country-code">
    <!--当前区号-->
    <div
      class="current-code"
      @click="pickHandler"
    >
      +{{ curCode }}
      <svg
        class="icon-img"
        :style="{transform: showCodeTable ? 'rotate(180deg)':''}"
      >
        <use xlink:href="#arr-down" />
      </svg>
    </div>
    <!--世界区号部分-->
    <span
      v-show="showCodeTable"
      class="angle-icon"
    />
    <div
      v-show="showCodeTable"
      ref="dropMenu"
      class="code-table"
    >
      <div class="search-area">
        <svg class="search-icon">
          <use xlink:href="#loupe" />
        </svg>
        <input
          v-model="searchVal"
          type="text"
          :placeholder="$t('搜索国家/地区')"
          class="search-input"
        >
      </div>
      <div class="common-area">
        <span
          :class="['common-item', currentAlpha === 'common' ? 'selected': '']"
          @click="sortBy('common')"
        >{{ $t('常用') }}</span>
        <span
          v-for="(alpha, i) in alphabet"
          :key="i"
          :class="['common-item', currentAlpha === alpha.toLowerCase() ? 'selected': '']"
          @click="sortBy(alpha)"
        >{{ alpha }}</span>
      </div>
      <div class="code-list">
        <div
          v-if="!countryList.length"
          class="code-none"
        >
          {{ $t('未找到相关国家或地区') }}
        </div>
        <div
          v-for="(item, inx) in countryList"
          v-else
          :key="inx"
          class="code-list-item"
          @click="changeCode(item.code)"
        >
          <span class="item-country">{{ item[lang] }}</span>
          <span class="item-code">{{ item.code }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getLanguage } from 'js/util/util'
import { countryCode } from 'js/api/countrycode.js'
import { pinyin } from 'js/api/convertSpell.js'

export default {
  data() {
    return {
      lang: getLanguage().toLowerCase(),
      currentAlpha: '',
      alphabet: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      countryList: [],
      curCode: '86',
      showCodeTable: false,
      searchVal: '',
    }
  },
  watch: {
    /**
         * 监听是否下拉菜单展示出来
         * 展开时注册全局click，收回时取消全局click
         */
    showCodeTable(val, oldVal) {
      if (val) {
        document.addEventListener('click', this.otherClick)
      } else {
        document.removeEventListener('click', this.otherClick)
      }
    },
    /**
         * 监听search值的变化
         */
    searchVal(val, oldVal) {
      if (val) {
        this.searchHandler()
      } else {
        this.countryList = countryCode
      }
    },
  },
  mounted() {
    this.countryList = countryCode
  },
  methods: {
    pickHandler() {
      this.showCodeTable = !this.showCodeTable
      this.$emit('pick')
    },
    loopArr(data, func) {
      if (Object.prototype.toString.call(data) === '[object Array]') {
        for (const i of data) {
          func(i)
        }
      }
    },
    changeCode(code = '86') {
      this.curCode = code.toString()
      this.$emit('codeChange', this.curCode)
      if (this.showCodeTable) this.showCodeTable = false
    },
    sortBy(key = 'common') {
      this.currentAlpha = key.toString().toLowerCase()
      const codeArr = []
      const vm = this
      if (key === 'common') { // common
        this.loopArr(countryCode, (item) => {
          if (item.common === 'common') {
            codeArr.push(item)
          }
        })
      } else if (this.lang === 'zh' || this.lang === 'tw') { // alphabetic
        this.loopArr(countryCode, (item) => {
          if (!item.pyAll) {
            item.pyAll = pinyin.getFullChars(item[vm.lang]).toUpperCase()
          }
          if (key === item.pyAll[0]) {
            codeArr.push(item)
          }
        })
      } else {
        this.loopArr(countryCode, (item) => {
          if (key === item.en[0]) {
            codeArr.push(item)
          }
        })
      }
      this.countryList = codeArr
    },
    /**
         * 防抖，在一定时间内只能操作一次
         */
    debounce(fn, delay = 400) {
      const vm = this
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        fn.call(vm)
      }, delay)
    },
    searchHandler() {
      const vm = this
      if (!this.searchVal.length) return
      this.debounce(() => {
        const codeArr = []
        vm.loopArr(countryCode, (item) => {
          if (vm.lang === 'zh' || vm.lang === 'tw') {
            if (!item.pyAll) {
              item.pyAll = pinyin.getFullChars(item[vm.lang]).toUpperCase()
            }
            if (!item.pySimple) {
              item.pySimple = pinyin.getCamelChars(item[vm.lang]).toUpperCase()
            }
          }
          const keyArr = [vm.lang, 'code', 'locale', 'pyAll', 'pySimple']
          for (const k of keyArr) {
            if (item.hasOwnProperty(k) && item[k].toString().toUpperCase().indexOf(vm.searchVal.toUpperCase()) > -1) {
              codeArr.push(item)
              break
            }
          }
        })
        vm.countryList = codeArr
      })
    },
    /**
         * 点击空白区域
         */
    otherClick(e) {
      const menuC = this.$refs.dropMenu
      if (menuC.contains(e.target)) {
        return
      }
      this.showCodeTable = false
    },
  },
}
</script>
<style lang="less" scoped>
// 样式定位部分
.country-code{
  position: absolute;
  .code-table{
    position: absolute;
    top: 38px;
    left: -3px;
  }
}
.country-code{
  .current-code{
    font-size: 14px;
    color: #1B2733;
    width: 63px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    box-sizing: border-box;
    float: left;
    border-radius: 2px;
    cursor: pointer;
    .icon-img{
      width: 8px;
      height: 4px;
      margin: 0 0 0 2px;
      vertical-align: middle;
      display: inline-block;
    }
  }
  .angle-icon{
    border: 5px solid beige;
    border-bottom: 5px solid #fff;
    border-right: 5px solid #fff;
    border-left: 5px solid transparent;
    border-top: 5px solid transparent;
    box-shadow: 0 2px 12px 0 rgba(27,39,51,0.15);
    position: absolute;
    top: 40px;
    left: 46px;
    transform: rotate(-135deg)
  }
  .code-table{
    width: 318px;
    height: 321px;
    margin-top: 5px;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.15);
    border-radius: 2px;
    overflow: hidden;
    .search-area{
      width: 286px;
      height: 38px;
      margin: 16px 16px 0px 16px;
      box-sizing: border-box;
      opacity: 0.3;
      background: #F0F2F6;
      border-radius: 2px;
      .search-icon{
        width: 16px;
        height: 16px;
        padding: 12px 0 0 12px;
        float: left;
      }
      .search-input{
        float: left;
        width: 254px;
        height: 38px;
        line-height: 38px;
        padding-left: 6px;
        font-size: 14px;
        color: #929CA9;
        background: #F0F2F6;
        outline: none;
        border: none;
        box-sizing: border-box;
      }
    }
    .common-area{
      overflow: hidden;
      padding: 12px 0;
      margin: 0 16px;
      border-bottom: 1px solid rgba(198, 205, 215, 0.4);
      .common-item{
        font-size: 14px;
        color: #1B2733;
        padding: 0 8px 0 0;
        cursor: pointer;
        float: left;
      }
      .selected{
        color: #0A64FA;
      }

    }
    .code-list{
      width: auto;
      height: 198px;
      padding: 12px 0 0 0;
      overflow-y: auto;
      overflow-x: hidden;
      box-sizing: border-box;
      .code-none{
        margin: 0 16px;
        color: #1B2733;
        font-size: 14px;
      }
      .code-list-item{
        overflow: hidden;
        font-size: 14px;
        color: #1B2733;
        height: 36px;
        line-height: 36px;
        padding: 0 16px;
        cursor: pointer;
        &:hover{
          background: #F0F2F6;
        }
        .item-country{
          float: left;
        }
        .item-code{
          float: right;
        }
      }
    }
  }
}
</style>
